<template>
	<div id="app">
		<header id="header" class="uk-padding-large uk-margin-large-bottom">
			<div class="content">
				<div class="uk-container uk-padding-small">
					<nav class="uk-navbar-container uk-navbar-transparent" uk-navbar>
						<div class="uk-navbar-left">
							<router-link to="/" tabindex="-1"><img src="./assets/immonex-one-logo-small.png" alt="Logo: immonex ONE - bullshitfreie Website für Immobilienmakler/innen" class="uk-margin-right"></router-link>

							<ul class="uk-navbar-nav uk-visible@m">
								<li>
									<strong>Die Website für Immobilienmakler/innen.</strong><br>
									Ohne Bullshit.
								</li>
								<li v-if="showFAQ"><router-link to="/#faq" @click.native="$root.scrollTo('#faq')" tabindex="-1">FAQ</router-link></li>
							</ul>
						</div>

						<div class="uk-navbar-right">
							<a uk-toggle="target: #offcanvas-nav" class="offcanvas-nav-toggle uk-hidden@m" style="margin-left:1em; text-decoration:none">Menü<span uk-icon="icon: chevron-right; ratio: 2" style="vertical-align:middle"></span><span uk-icon="icon: menu; ratio: 2" style="vertical-align:middle"></span></a>

							<ul class="uk-navbar-nav uk-visible@m">
								<li v-if="this.signupEnabled"><a href="#terms-modal" tabindex="-1" uk-toggle>AGB</a></li>
								<li v-if="this.$route.name !== 'datenschutz'"><a href="#privacy-modal" tabindex="-1" uk-toggle>Datenschutz</a></li>
								<li v-if="this.$route.name !== 'impressum'"><a href="#legal-modal" tabindex="-1" uk-toggle>Impressum</a></li>
							</ul>
						</div>
					</nav>
				</div>
			</div>

			<div class="fade-out"></div>
		</header>

		<nav id="offcanvas-nav" uk-offcanvas="flip: true; mode: reveal; overlay: true; container: body">
			<div class="uk-offcanvas-bar">
				<button class="uk-offcanvas-close" type="button" uk-close></button>

				<ul class="uk-nav uk-nav-default">
					<ul class="uk-navbar-nav">
						<li><a href="#terms-modal" tabindex="-1" uk-toggle>AGB</a></li>
						<li v-if="this.$route.name !== 'datenschutz'"><a href="#privacy-modal" tabindex="-1" uk-toggle>Datenschutz</a></li>
						<li v-if="this.$route.name !== 'impressum'"><a href="#legal-modal" tabindex="-1" uk-toggle>Impressum</a></li>
					</ul>
				</ul>
			</div>
		</nav>


		<div id="content">
			<router-view />
		</div>

		<div id="terms-modal" class="uk-modal-container" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<h2 class="uk-modal-title">Allgemeine Geschäftsbedingungen (AGB)</h2>

				<terms></terms>

				<p class="uk-text-right">
					<button class="uk-button uk-button-default uk-modal-close" type="button">Ok!</button>
				</p>
			</div>
		</div>

		<div id="privacy-modal" class="uk-modal-container" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<h2 class="uk-modal-title">Privatsphäre und Datenschutz</h2>

				<privacy></privacy>

				<p class="uk-text-right">
					<button class="uk-button uk-button-default uk-modal-close" type="button">Ok!</button>
				</p>
			</div>
		</div>

		<div id="legal-modal" class="uk-modal-container" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<h2 class="uk-modal-title">Impressum</h2>

				<legal></legal>

				<p class="uk-text-right">
					<button class="uk-button uk-button-default uk-modal-close" type="button">Ok!</button>
				</p>
			</div>
		</div>

		<!--div class="footer">
			<nav>
				<ul>
					<li><span uk-icon="home"></span></li>
					<li><span uk-icon="cog"></span></li>
					<li>Kontakt</li>
					<li>Datenschutz</li>
					<li>Impressum</li>
				</ul>
			</nav>
		</div-->

		<portal-target name="signup-overlays"></portal-target>
	</div>
</template>

<script>
import UIkit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'
UIkit.use(Icons)

import Terms from './views/Terms.vue'
import Privacy from './views/Privacy.vue'
import Legal from './views/Legal.vue'

export default {
	name: 'App',
	data () {
		return {
			signupEnabled: false,
			showFAQ: false
		}
	},
	components: { Terms, Privacy, Legal },
	mounted () {
		this.signupEnabled = process.env.VUE_APP_SIGNUP_ENABLED == 1 ? true : false

		if (this.$route.hash) {
			setTimeout(() => this.$root.scrollTo(this.$route.hash), 1)
		}
	}
}
</script>

<style lang="scss">
@import "uikit/src/scss/variables-theme.scss";
@import "uikit/src/scss/mixins-theme.scss";
@import "uikit/src/scss/uikit-theme.scss";

@import "./fonts/stylesheet.css";

html {
	min-height: 100%;
	background-color: #D2D2D2;
}

body {
	font-family: rubikregular, Roboto, "Helvetica Neue", Arial, sans-serif !important;
}

em {
	color: #E77A06;
}

#content {
	a {
		color: #39F;
	}

	a:hover {
		color: #0F7AE5;
		text-decoration: none;
	}

	h1, h2, h3, p {
		font-family: rubikregular, Roboto, "Helvetica Neue", Arial, sans-serif !important;
	}

	h1 {
		font-size: 2em;
		font-weight: bold;
	}

	h2 {
		font-size: 1.5em;
	}
}

a.offcanvas-nav-toggle {
	color: #999;
}

a.offcanvas-nav-toggle:hover {
	color: #666;
}

#offcanvas-nav {
	.uk-navbar-nav {
		display: block;

		li > a {
			display: inline-block;
			min-height: auto;
			text-decoration: none;
		}
	}
}

#header {
	background-color: #FFF;
}

/* #header .content {
	background: rgba(60, 59, 49, .96);
}

#header .fade-out {
	height: 1em;
	background: rgba(60, 59, 49, .96);
	background: linear-gradient(0, rgba(60, 59, 49, 0), rgba(60, 59, 49, .4));
} */

.footer {
	padding-top: 8em;
	color: #E0E0E0;
	background-color: #666;
	font-size: .7em;

	ul {
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		align-items: center;
		padding: 0;
		list-style-type: none;

		li {
			padding: 2em .4em;
			text-transform: uppercase;
		}
	}
}

.content-header {
	margin-bottom: 1rem;
}

.content-body {
	flex: 1;
}

.content-footer{
	margin-top: 2rem;
}

.text-highlight {
	font-weight: 500;
	color: #E77A06 !important;
}

.action-content-section {
	max-width: 50em;
	background-color: #39F;
	color: #FFF;
}

/* UIkit-Anpassungen */

.uk-navbar-nav > li > a {
	font-family: rubikregular, Roboto, "Helvetica Neue", Arial, sans-serif !important;
}

.uk-icon {
	vertical-align: top;
	padding-top: 2px;
}

.uk-icon.icon-check {
	padding-top: 2px;
}

.uk-icon-button,
.uk-light .uk-icon-button {
	color: #FFF;
	background-color: #39F;
}

.uk-icon-button:hover,
.uk-light .uk-icon-button:hover {
	color: #FFF;
	background-color: #0F7AE5;
}

.uk-sticky-placeholder {
	margin-bottom: 2em !important;
}

.uk-button.uk-button-large {
	font-size: 1.5rem;
}
</style>
